import {useSelector} from "react-redux";

function useLang(){
    return useSelector(state => state.app.lang);
}

export default useLang;
